import {axios} from "@/api/config";

// 查询四色图管理列表
export function listSafechart(params) {
  return axios.get(`/safechart/list`, params, true);
}

// 查询四色图管理详细
export function getSafechart(id) {
  return axios.get(`/safechart/${id}`, id, true)
}

// 新增四色图管理
export function addSafechart(params) {
  return axios.post('/safechart/addSafechart', params, false);
}

// 修改四色图管理
export function updateSafechart(params) {
  return axios.post('/safechart/editSafechart', params, false);
}


// 删除四色图管理
export function delSafechart(id) {
  return axios.delete(`/safechart/${id}`, true)
}

